import React, { useState, useEffect, useRef } from "react";
import Immutiverse_logo from "../assets/icons/Immutaverse+Blue+White+Logo.webp";
import AnimatedButton from "./AnimatedButton";
import useMediaQuery from "@mui/material/useMediaQuery";

import {
  HeaderConatiner,
  AppBar,
  ImmutiverseLogo,
  HeaderLeft,
  NavigationLinks,
  StyledNavLink,
  NavButton,
  Caret,
  DropdownContainer,
  DropdownMenu,
  DropdownItem,
  DemoButton,
  DemoArrow,
  LogOutBtn,
  Hamburger,
  MobileMenu,
  MobileHeader,
  CloseIcon,
  MobileLink,
  MobileSubLink,
  MobileSection,
  BottomButtons,
} from "../assets/styles/HeaderStyled";

const HeaderContainer = () => {
  const [platformOpen, setPlatformOpen] = useState(false);
  const [solutionsOpen, setSolutionsOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileExpanded, setMobileExpanded] = useState(null);
  const [activeLink, setActiveLink] = useState("risk-calculator");

  const platformRef = useRef(null);
  const solutionsRef = useRef(null);
  const resourcesRef = useRef(null);

  const isMobile = useMediaQuery("(max-width: 900px)");

  useEffect(() => {
    const p = window.location.pathname;
    if (p.includes("immutaverse-origin")) setActiveLink("origin");
    else if (p.includes("immutaverse-radar")) setActiveLink("radar");
    else if (p.includes("immutaverse-regen")) setActiveLink("regen");
    else if (p.includes("immutaverse-apex")) setActiveLink("apex");
    else if (p.includes("new-product-introduction")) setActiveLink("npi");
    else if (p.includes("device-security")) setActiveLink("device-security");
    else if (p.includes("regulatory-compliance")) setActiveLink("regulatory");
    else if (p.includes("blog")) setActiveLink("blog");
    else if (p.includes("pricing")) setActiveLink("pricing");
    else if (p.includes("about") || p.includes("company")) setActiveLink("company");
    else setActiveLink("risk-calculator");
  }, []);

  const toggleMobile = (key) => setMobileExpanded((prev) => (prev === key ? null : key));

  const handleDisabledClick = (e) => {
  };

  const handleMouseEnter = (setter) => {
    setter(true);
  };

  const handleMouseLeave = (setter, ref) => {
    setTimeout(() => {
      if (ref.current && !ref.current.matches(':hover')) {
        setter(false);
      }
    }, 100);
  };

  return (
    <HeaderConatiner>
      <AppBar>
        <HeaderLeft>
          <div style={{ cursor: "default" }} onClick={handleDisabledClick}>
            <ImmutiverseLogo
              src={Immutiverse_logo}
              alt="Immutaverse Logo"
              width={250}
              height={80}
              loading="lazy"
              menuOpen={menuOpen}
              style={{ cursor: "default" }}
            />
          </div>

          <NavigationLinks>
            {/* Platform */}
            <DropdownContainer
              ref={platformRef}
              onMouseEnter={() => handleMouseEnter(setPlatformOpen)}
              onMouseLeave={() => handleMouseLeave(setPlatformOpen, platformRef)}
            >
              <NavButton open={platformOpen} active={["origin", "radar", "regen", "apex"].includes(activeLink)}>
                Platform <Caret open={platformOpen} />
              </NavButton>
              <DropdownMenu open={platformOpen}>
                <DropdownItem
                  href="https://www.immutaverse.com/immutaverse-apex"
                  active={activeLink === "apex"}
                  onClick={handleDisabledClick}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  Immutaverse Apex
                </DropdownItem>
                <DropdownItem
                  href="https://www.immutaverse.com/immutaverse-origin"
                  active={activeLink === "origin"}
                  onClick={handleDisabledClick}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  Immutaverse Origin
                </DropdownItem>
                <DropdownItem
                  href="https://www.immutaverse.com/immutaverse-radar"
                  active={activeLink === "radar"}
                  onClick={handleDisabledClick}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  Immutaverse Radar
                </DropdownItem>
                <DropdownItem
                  href="https://www.immutaverse.com/immutaverse-regen"
                  active={activeLink === "regen"}
                  onClick={handleDisabledClick}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  Immutaverse Regen
                </DropdownItem>
              </DropdownMenu>
            </DropdownContainer>

            {/* Solutions */}
            <DropdownContainer
              ref={solutionsRef}
              onMouseEnter={() => handleMouseEnter(setSolutionsOpen)}
              onMouseLeave={() => handleMouseLeave(setSolutionsOpen, solutionsRef)}
            >
              <NavButton open={solutionsOpen} active={["npi", "device-security", "regulatory"].includes(activeLink)}>
                Solutions <Caret open={solutionsOpen} />
              </NavButton>
              <DropdownMenu open={solutionsOpen} style={{ minWidth: "260px" }}>
                <DropdownItem
                  href="https://www.immutaverse.com/scalable-oem-device-security-workflows"
                  active={activeLink === "npi"}
                  onClick={handleDisabledClick}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  Scalable OEM Device Security Workflows
                </DropdownItem>
                <DropdownItem
                  href="https://www.immutaverse.com/oem-new-product-introduction"
                  active={activeLink === "device-security"}
                  onClick={handleDisabledClick}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  OEM New Product Introduction
                </DropdownItem>
                <DropdownItem
                  href="https://www.immutaverse.com/product-security-regulatory-compliance"
                  active={activeLink === "regulatory"}
                  onClick={handleDisabledClick}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  Product Security Regulatory Compliance
                </DropdownItem>
              </DropdownMenu>
            </DropdownContainer>

            {/* Resources */}
            <DropdownContainer
              ref={resourcesRef}
              onMouseEnter={() => handleMouseEnter(setResourcesOpen)}
              onMouseLeave={() => handleMouseLeave(setResourcesOpen, resourcesRef)}
            >
              <NavButton open={resourcesOpen} active={["blog", "risk-calculator"].includes(activeLink)}>
                Resources <Caret open={resourcesOpen} />
              </NavButton>
              <DropdownMenu open={resourcesOpen}>
                <DropdownItem
                  href="https://www.immutaverse.com/blog"
                  active={activeLink === "blog"}
                  onClick={handleDisabledClick}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  Blog
                </DropdownItem>
                <DropdownItem
                  href="https://app.immutaverse.com"
                  active={activeLink === "risk-calculator"}
                  onClick={handleDisabledClick}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  Risk Calculator
                </DropdownItem>
              </DropdownMenu>
            </DropdownContainer>

            {/* Pricing */}
            <StyledNavLink href="https://www.immutaverse.com/pricing" active={activeLink === "pricing"} onClick={handleDisabledClick}>
              Pricing
            </StyledNavLink>

            {/* Company */}
            <StyledNavLink href="https://www.immutaverse.com/company" active={activeLink === "company"} onClick={handleDisabledClick}>
              Company
            </StyledNavLink>
          </NavigationLinks>
        </HeaderLeft>


        {/* Desktop Right */}
        {!isMobile && (
          <div style={{ display: "flex", alignItems: "center", gap: "1.5rem", marginLeft: "auto" }}>
            <DemoButton
              as="a"
              href="https://meetings-na2.hubspot.com/immutaverse/demo-meeting?uuid=8c0a14b8-410d-45b5-a30c-4632d2a66192"
              onClick={handleDisabledClick}
              target="_blank"
              rel="noopener noreferrer"
            >
              Get a demo
              <DemoArrow>→</DemoArrow>
            </DemoButton>
          </div>
        )}
        {/* Mobile Hamburger */}
        {isMobile && (
          <div style={{ marginLeft: "auto" }}>
            <Hamburger open={menuOpen} onClick={() => setMenuOpen((v) => !v)}>
              <span /><span /><span />
            </Hamburger>
          </div>
        )}
      </AppBar>

      {/* Mobile Menu */}
      <MobileMenu open={menuOpen}>
        <MobileHeader>
          <CloseIcon onClick={() => setMenuOpen(false)}>×</CloseIcon>
        </MobileHeader>

        <MobileSection>
          <MobileLink onClick={() => toggleMobile("platform")}>
            Platform <span style={{ fontSize: "0.75rem" }}>{mobileExpanded === "platform" ? "▲" : "▼"}</span>
          </MobileLink>
          {mobileExpanded === "platform" && (
            <>
              <MobileSubLink href="https://www.immutaverse.com/immutaverse-apex" onClick={handleDisabledClick}>Immutaverse Apex</MobileSubLink>
              <MobileSubLink href="https://www.immutaverse.com/immutaverse-origin" onClick={handleDisabledClick}>Immutaverse Origin</MobileSubLink>
              <MobileSubLink href="https://www.immutaverse.com/immutaverse-radar" onClick={handleDisabledClick}>Immutaverse Radar</MobileSubLink>
              <MobileSubLink href="https://www.immutaverse.com/immutaverse-regen" onClick={handleDisabledClick}>Immutaverse Regen</MobileSubLink>
            </>
          )}
        </MobileSection>

        <MobileSection>
          <MobileLink onClick={() => toggleMobile("solutions")}>
            Solutions <span style={{ fontSize: "0.75rem" }}>{mobileExpanded === "solutions" ? "▲" : "▼"}</span>
          </MobileLink>
          {mobileExpanded === "solutions" && (
            <>
              <MobileSubLink href="https://www.immutaverse.com/new-product-introduction" onClick={handleDisabledClick}>New Product Introduction</MobileSubLink>
              <MobileSubLink href="https://www.immutaverse.com/scalable-device-security-workflows" onClick={handleDisabledClick}>Scalable Device Security Workflows</MobileSubLink>
              <MobileSubLink href="https://www.immutaverse.com/regulatory-compliance" onClick={handleDisabledClick}>Regulatory Compliance</MobileSubLink>
            </>
          )}
        </MobileSection>

        <MobileSection>
          <MobileLink onClick={() => toggleMobile("resources")}>
            Resources <span style={{ fontSize: "0.75rem" }}>{mobileExpanded === "resources" ? "▲" : "▼"}</span>
          </MobileLink>
          {mobileExpanded === "resources" && (
            <>
              <MobileSubLink href="https://www.immutaverse.com/blog" onClick={handleDisabledClick}>Blog</MobileSubLink>
              <MobileSubLink href="https://www.app.immutaverse.com" onClick={handleDisabledClick}>Risk Calculator</MobileSubLink>
            </>
          )}
        </MobileSection>

        <MobileSection>
          <MobileLink as="a" href="https://www.immutaverse.com/pricing" onClick={handleDisabledClick}>Pricing</MobileLink>
        </MobileSection>

        <MobileSection>
          <MobileLink as="a" href="https://www.immutaverse.com/company" onClick={handleDisabledClick}>Company</MobileLink>
        </MobileSection>

        {/* <BottomButtons>
          <AnimatedButton text="Get a demo" onClick={handleDisabledClick} />
          <LogOutBtn onClick={handleDisabledClick}>Log Out</LogOutBtn>
        </BottomButtons> */}
      </MobileMenu>
    </HeaderConatiner>
  );
};

export default HeaderContainer;